import {
  REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44,
  REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54,
  REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64,
  REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER,
  REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35,
} from './constants';
import { TargetScoreRangeAgeGroup } from '../../../TargetScore';

export function getRtBreakpointsFromAgeGroup(ageGroup: TargetScoreRangeAgeGroup) {
  switch (ageGroup) {
    case 'Under35':
      return REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35;
    case '35To44':
      return REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44;
    case '45To54':
      return REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54;
    case '55To64':
      return REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64;
    case '65AndOver':
      return REAL_ESTATE_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER;
    default:
      return [];
  }
}
